import { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";

const reelCode = (reel) => {
  if (!reel) return null;
  const m = String(reel).match(/\/(?:reel|reels|p|tv)\/([^/?#]+)/);
  return m ? m[1] : String(reel).replace(/[^A-Za-z0-9_-]/g, "") || null;
};

export default function VideoModal({ video, onClose }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  const code = video ? reelCode(video.reel) : null;

  return (
    <AnimatePresence>
      {video && (
        <motion.div
          data-testid="video-modal"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.35 }}
          className="fixed inset-0 z-[90] flex items-center justify-center bg-charcoal-950/90 p-4 backdrop-blur-md md:p-10"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.92, y: 24 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 12 }}
            transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
            className={`relative w-full ${code ? "max-w-[400px]" : "max-w-5xl"}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              data-testid="video-modal-close"
              onClick={onClose}
              aria-label="Videoyu kapat"
              className="absolute -top-12 right-0 flex h-10 w-10 items-center justify-center rounded-full border border-white/20 bg-white/10 text-white backdrop-blur transition-colors duration-300 hover:bg-white/20"
            >
              <X className="h-5 w-5" />
            </button>
            <p className="mb-3 font-accent text-xs uppercase tracking-[0.3em] text-gold-light">
              {video.subtitle ? `${video.subtitle} — ` : ""}{video.title}
            </p>
            {code ? (
              <div
                data-testid="video-modal-reel"
                className="relative overflow-hidden rounded-2xl bg-black shadow-lift"
                style={{ height: "min(84vh, 720px)" }}
              >
                <iframe
                  title={video.title}
                  src={`https://www.instagram.com/reel/${code}/embed/`}
                  className="h-full w-full"
                  scrolling="no"
                  allow="autoplay; encrypted-media; clipboard-write; picture-in-picture"
                  allowFullScreen
                  style={{ border: 0 }}
                />
              </div>
            ) : (
              <video
                src={video.src}
                poster={video.poster}
                controls
                autoPlay
                playsInline
                className="aspect-video w-full rounded-2xl bg-black shadow-lift"
              />
            )}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
